export default __webpack_public_path__ + "static/media/upload-file.b62b07a3.svg";